import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../../../shared/i18n/index.js';

export function ForbiddenPage(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div role="alert" aria-label="forbidden" data-testid="page-forbidden" style={{ padding: 48, textAlign: 'center' }}>
      <h1 style={{ fontSize: 'var(--font-size-3xl)', color: 'var(--color-danger)' }}>403</h1>
      <p>{t('errors.403.body')}</p>
      <p style={{ color: 'var(--color-text-muted)', fontSize: 'var(--font-size-sm)' }}>
        {t('errors.403.hint')}
      </p>
      <Link to="/dashboard">{t('errors.returnDashboard')}</Link>
    </div>
  );
}
